import { Link, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import ContentSharer from "./ContentSharer";
import HtmlContent from "../../components/general/misc/HtmlContent";
import LocalizedDate from "../../components/general/misc/LocalizedDate";
import NewsAvatar from "../../components/general/misc/NewsAvatar";
import SectionTitle from "../../components/general/misc/SectionTitle";
import { getPostDetail } from "../../services/newsRequestServices";
import styled from "styled-components";
import variables from "../../assets/js/variables";
import { toPersianNumber } from "../../utilities/persianNumber";

const { colors, gridBreakpoints } = variables;

const NewsDetail = () => {
  const { origin } = window.location;
  const { id } = useParams();
  const [newsData, changeNewsData] = useState(null);

  const getNewsData = useCallback(() => {
    return getPostDetail(id).then((res) => changeNewsData(res));
  }, [id]);

  useEffect(() => {
    getNewsData();
  }, [getNewsData]);
  console.log(newsData?.abs_content);
  return (
    <Styles className="d-flex flex-column">
      <TitleRow className="d-flex flex-column flex-md-row align-items-start align-items-md-center w-100 mb-3">
        <NewsAvatar
          className="ms-4 d-none d-md-block"
          size={160}
          photo={newsData?.icon}
          alt={newsData?.title}
        />
        <div className="d-flex flex-column align-items-start flex-grow-1">
          <Link
            to={`/news/?category=${newsData?.category.id}`}
            className="text-16 text-green mb-3"
          >
            {newsData?.category.title}
          </Link>
          <SectionTitle className="mb-3" text={newsData?.title} />
          <NewsMeta className="text-14 text-white font-weight-100">
            {newsData?.author}
            <LocalizedDate date={newsData?.published_on} format="، MMMM YYYY" />
          </NewsMeta>
        </div>
        <Link
          to="/news"
          className="btn btn-sm px-4 bg-green text-black border-radius-10 justify-self-end me-md-4"
        >
          مشاهده همه تازه‌ها
        </Link>
      </TitleRow>
      <NewsBody className="d-flex flex-column flex-xl-row flex-wrap">
        <NewsContent className="d-flex flex-column mt-0">
          <NewsText>
            <div className="text-14 font-weight-500 text-white mb-5">
              <HtmlContent
                rawHtml={toPersianNumber(String(newsData?.abs_content))}
              />
            </div>
            <div className="text-14 font-weight-300 text-white-smoke">
              <HtmlContent
                rawHtml={toPersianNumber(String(newsData?.content))}
              />
            </div>
          </NewsText>
          {newsData?.tags.length && (
            <div className="mt-3">
              <h3 className="text-14 text-white mt-4">برچسب‌های مرتبط:</h3>
              <ButtonGroup>
                {newsData?.tags.map((item, index) => (
                  <Link
                    key={item.id + index + "1"}
                    to={`/news/?tag=${item.id}`}
                    className="btn px-2 text-12 text-white-smoke border-radius-8 links-tags"
                  >
                    {item.title}
                  </Link>
                ))}
              </ButtonGroup>
            </div>
          )}
        </NewsContent>
        <RelatedNewsList className="d-flex flex-column">
          <h4 className="text-16 text-white">مطالب مرتبط</h4>
          {(newsData?.related_links ?? []).length ? (
            <div className="d-flex flex-column">
              {(newsData.related_links ?? []).map((item, index) => (
                <RelatedNewItem key={index * 1 + 9} item={item} />
              ))}
            </div>
          ) : (
            <p className="text-12 text-white">مطلبی پیدا نشد.</p>
          )}
        </RelatedNewsList>
      </NewsBody>
      <NewsShare className="d-flex flex-row align-items-center share-page">
        <h4 className="text-white text-14 m-0 ms-5 ">
          این صفحه‌ را به اشتراگ بگذارید
        </h4>
        <ContentSharer url={`${origin}/news/${newsData?.id}`} />
      </NewsShare>
    </Styles>
  );
};

const RelatedNewItem = ({ item }) => {
  return (
    <div className="related__news-item d-flex flex-column align-items-start">
      <span className="text-12 text-green mb-2">{item.type}</span>
      <a href={item.url} className="text-16 text-white line-height-2x">
        {item.title}
      </a>
    </div>
  );
};

export default NewsDetail;

const TitleRow = styled.div`
  background-color: ${colors.darkBlue};
  padding: 2rem 6rem;
  align-items: center;
  @media (max-width: 768px) {
    padding: 2rem 2rem;
  }

  > a {
    border-bottom: solid 1px transparent;

    &:hover {
      border-bottom-color: inherit;
    }
  }
`;

const NewsMeta = styled.p`
  opacity: 0.75;
`;

const NewsBody = styled.div`
  margin: 1.5rem 6rem;
  padding-bottom: 2rem;
  position: relative;
  border-bottom: solid 1px ${colors.brand};
  @media (max-width: 768px) {
    margin: 1.5rem 2rem;
  }
  /* @media (min-width: ${gridBreakpoints.md + 1}px) {
    padding-right: calc(1.5rem + 50px);
  } */
`;

const NewsContent = styled.section`
  flex-grow: 1;

  @media (max-width: ${gridBreakpoints.xl}px) {
    width: 100;
  }

  @media (min-width: ${gridBreakpoints.xl + 1}px) {
    max-width: calc(100% - 260px - 6rem);
  }
`;

const NewsText = styled.div`
  line-height: 24px !important;

  p,
  img,
  figure,
  ul,
  ol {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }

  img {
    background-color: ${colors.brand};
    border-radius: 1rem;
    padding: 0.3rem;
    margin-left: auto;
    margin-right: auto;
    display: block;
    max-width: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colors.green};
    margin-bottom: 1rem;
  }
`;

const ButtonGroup = styled.div`
  a {
    border: solid 1px ${colors.brand};
  }

  a + a {
    margin-right: 1rem;
  }
`;

const RelatedNewsList = styled.section`
  h4,
  .related__news-item:not(:last-child) {
    padding-bottom: 1rem;
    border-bottom: solid 1px ${colors.brand};
    margin-bottom: 1rem;
  }

  @media (max-width: ${gridBreakpoints.xl}px) {
    margin-top: 4rem;
  }

  @media (min-width: ${gridBreakpoints.xl + 1}px) {
    margin-right: 6rem;
    width: 250px;
  }
`;

const NewsShare = styled.section`
  margin: 0 6rem;

  @media (min-width: ${gridBreakpoints.md + 1}px) {
    padding-right: calc(1.5rem + 160px);
  }
`;

const Styles = styled.div`
  @media (max-width: 550px) {
    .share-page {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      width: 85%;
      h4 {
        margin: 0 !important;
      }
    }
    .links-tags {
      margin-bottom: 10px;
    }
  }
`;
